
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface TestCallResultsProps {
  testResult: {
    audioUrl?: string | null;
    transcript?: string;
    intentOutput?: string;
  } | null;
}

const TestCallResults = ({ testResult }: TestCallResultsProps) => {
  if (!testResult) return null;

  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Test Call Results</CardTitle>
        <CardDescription>
          Generated audio, transcription, and intent analysis
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {testResult.audioUrl && (
          <div>
            <h3 className="text-sm font-medium mb-2">Generated Audio</h3>
            <audio 
              src={testResult.audioUrl} 
              controls 
              className="w-full"
            />
          </div>
        )}
        
        {testResult.transcript && (
          <div>
            <h3 className="text-sm font-medium mb-2">Call Transcript</h3>
            <div className="bg-muted p-3 rounded-md whitespace-pre-wrap text-sm">
              {testResult.transcript}
            </div>
          </div>
        )}
        
        {testResult.intentOutput && (
          <div>
            <h3 className="text-sm font-medium mb-2">Intent Analysis</h3>
            <div className="bg-muted p-3 rounded-md whitespace-pre-wrap text-sm">
              {testResult.intentOutput}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TestCallResults;
